/* eslint-disable */
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';

const createHistory = require("history").createBrowserHistory
import { ConnectedRouter } from 'react-router-redux'
import { IndexRoute, Route} from 'react-router-dom'
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Maintenance from './components/Maintenance';
import Report from './components/Report';
import Certificates from './components/Certificates';
import CertificateCheck from './components/CertificateCheck';
import ReportCheck from './components/ReportCheck';
import FormCertificates from './components/FormCertificates';
import AssetsProducing from './components/AssetsProducing';
import AssetsProducingArchived from './components/AssetsProducingArchived';
import AssetsConsuming from './components/AssetsConsuming';
import AssetsConsumingArchived from './components/AssetsConsumingArchived';

import AssetProducing from './components/AssetProducing';
import AssetConsuming from './components/AssetConsuming/AssetConsuming';
import FormAssetsProducing from './components/FormAssetsProducing';
import FormAssetsConsuming from './components/FormAssetsConsuming';
import AuthCallback from './components/AuthCallback';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import configureStore from './store';
import { I18nextProvider } from "react-i18next";
import { PersistGate } from 'redux-persist/integration/react'

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { theme } from './theme';
import i18n from "./i18n";

export const history = createHistory()
const configureStoreAndPersistor = configureStore(history);

let store = configureStoreAndPersistor.store;
let persistor = configureStoreAndPersistor.persistor;

render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedRouter history={history}>
        <MuiThemeProvider theme={theme}>
          <I18nextProvider i18n={i18n}>
            <App history={history}>
              <Route exact path="/" component={Login} />
              <Route exact path="/get-user-on-authentication" component={AuthCallback} />

              <Route exact path="/dashboard" component={Dashboard} />
              <Route exact path="/assets/prod" component={AssetsProducing}/>
              <Route exact path="/assets/prod/archived" component={AssetsProducingArchived}/>
              <Route exact path="/assets/prod/create" component={FormAssetsProducing} />
              <Route exact path="/assets/prod/update/:assetId" component={FormAssetsProducing}/>
              <Route exact path="/assets/prod/read/:assetId" component={AssetProducing} />

              <Route exact path="/assets/cons" component={AssetsConsuming}/>
              <Route exact path="/assets/cons/archived" component={AssetsConsumingArchived}/>
              <Route exact path="/assets/cons/create" component={FormAssetsConsuming} />
              <Route exact path="/assets/cons/update/:assetId" component={FormAssetsConsuming}/>
              <Route exact path="/assets/cons/read/:assetId" component={AssetConsuming} />

              <Route exact path="/certificates" component={Certificates}/>
              <Route exact path="/certificates/check" component={CertificateCheck} />
              <Route exact path="/reports/check" component={ReportCheck} />
              <Route exact path="/certificates/create" component={FormCertificates} />

              <Route exact path="/maintenance" component={Maintenance} />
              <Route exact path="/report" component={Report} />
            </App>
          </I18nextProvider>
        </MuiThemeProvider>
      </ConnectedRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
)

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js